// Voeg hier je eigen custom JavaScript toe. Let op: Gebruik geen jQuery, maar vanilla JavaScript.

// On document ready:
document.addEventListener('DOMContentLoaded', function () {
    // Add your custom JavaScript here.
    // NOTE: This script will be loaded on every page AND in the Gutenberg editor.
    console.log('Page loaded!');
});

window.addEventListener('scroll', function() {
    const nav = document.querySelector('.site-header');
    if (window.scrollY > 50) { // Na 50px scrollen...
        nav.classList.add('scrolled');
    } else {
        nav.classList.remove('scrolled');
    }
});
